<template>
    <router-view/>
</template>

<script>
    // import Authentication from './util/Authentication'

    export default {
        name: 'App'
        // store is injected via app.use(store) in main.js
        // updated() {
        //     if (!Authentication.isUserAuthenticated()) {
        //         this.$router.push('/login');
        //     }
        // }
    }
</script>

<style lang="scss">
  // Import Main styles for this application
  @import '@/styles/bootstrap.scss';
  @import '@/styles/app.scss';
  @import '@/styles/custom.scss';
  
  // Modern theme overrides
  @import '@/styles/modern-theme.scss';
</style>
 